<script setup>
    import { computed } from 'vue'
    import noUser from '@/assets/images/no_user.svg'

    const props = defineProps({
        variant: {
            type: String,
            required: true,
            validator: (value) => ['agent', 'bubble'].includes(value),
        },
        avatar: {
            type: String,
            default: '',
        },
        bgColor: {
            type: String,
            default: '#000000',
        },
        title: {
            type: String,
            default: 'Atendimento',
        },
        bubbleSize: {
            type: Number,
            default: 76,
        },
    })

    const agentAvatarSrc = computed(() => props.avatar || noUser)

    const bubbleStyle = computed(() => {
        const size = Math.min(Math.max(props.bubbleSize, 56), 120)

        return {
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: props.bgColor,
        }
    })

    function onImageError(event) {
        event.target.src = noUser
    }
</script>

<template>
    <div
        class="rounded-lg border border-dashed border-gray-300 dark:border-neutral-600 bg-gray-50 dark:bg-neutral-800/50 p-3"
        aria-hidden="true"
    >
        <!-- Preview: header do chat aberto -->
        <div
            v-if="variant === 'agent'"
            class="overflow-hidden rounded-md border border-gray-200 dark:border-neutral-600 bg-white dark:bg-neutral-900 shadow-sm"
        >
            <div
                class="flex items-center gap-2 px-2 py-2"
                :style="{ backgroundColor: bgColor }"
            >
                <div class="h-9 w-9 flex-shrink-0 overflow-hidden rounded-full border-2 border-white bg-white/10">
                    <img
                        :src="agentAvatarSrc"
                        alt=""
                        class="h-full w-full object-cover object-center"
                        @error="onImageError"
                    >
                </div>
                <div class="min-w-0 flex-1 text-white">
                    <p class="truncate text-xs font-medium">{{ title }}</p>
                    <p class="text-[10px] opacity-70">Em andamento</p>
                </div>
            </div>
            <div class="h-16 bg-white dark:bg-neutral-900" />
        </div>

        <!-- Preview: balão fechado no site -->
        <div
            v-else
            class="relative h-24 overflow-hidden rounded-md border border-gray-200 dark:border-neutral-600 bg-white dark:bg-neutral-900"
        >
            <div class="absolute inset-0 bg-gradient-to-t from-gray-100/80 to-transparent dark:from-neutral-800/80" />
            <div
                class="absolute bottom-2 right-2 flex items-center justify-center overflow-hidden rounded-full shadow-lg"
                :style="bubbleStyle"
            >
                <img
                    v-if="avatar"
                    :src="avatar"
                    alt=""
                    class="h-full w-full object-cover object-center"
                    @error="onImageError"
                >
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="h-6 w-6 text-white"
                    aria-hidden="true"
                >
                    <path d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2z" />
                </svg>
            </div>
        </div>
    </div>
</template>
